import React from 'react';

import { useSettings, useSession } from '@cordata/buffet';
import { ThemeProvider as Base } from 'styled-components';

type tThemeProviderProps = {
  children: React.ReactNode,
};

const DEFAULT_THEME = {
  color: { primary: 'blue' },
};

const ThemeProvider = (props: tThemeProviderProps) => {
  const { isAuthed } = useSession();
  const settings = useSettings();

  const theme = isAuthed && settings ? JSON.parse(settings.theme.settingValue) : DEFAULT_THEME;

  return (
    <Base theme={theme} {...props} />
  );
};

export default ThemeProvider;
